export default "__VITE_ASSET__BJ015ESw__"